// @flow

import * as React from 'react';
import classNames from 'classnames';

import * as css from './Loader.scss';

type Props = {
	className?: string,
	size?: string,
};

const Loader = ({ className, size }: Props) => {
	return <div className={classNames(css.loader, className, css[size])} />;
};

Loader.SMALL = 'small';

Loader.defaultProps = {
	className: '',
	size: Loader.SMALL,
};

export default Loader;
